import { getAuthValue } from "../modules/authModule/hooks/useAuthValue";
import { USER_ROLES } from "../modules/userModule/types/CommonTypes";

const OT_MANAGER_ACCESS = [
  USER_ROLES.OT_MANAGER,
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.ADMIN,
];
export const NURSE_ACCESS = [USER_ROLES.NURSE, USER_ROLES.CHARGE_NURSE];

export const CASE_SCHEDULER_ACCESS = [USER_ROLES.OT_MANAGER, USER_ROLES.ADMIN];

export enum USER_ROLE_ACCESS_KEY {
  OT_MANAGER = "OT_MANAGER",
  NURSE = "NURSE",
  CASE_SCHEDULER = "CASE_SCHEDULER",
}

function getUserRoleAccess(accessKey: USER_ROLE_ACCESS_KEY) {
  const { user } = getAuthValue();

  if (!user?.role) {
    return false;
  }

  switch (accessKey) {
    case USER_ROLE_ACCESS_KEY.OT_MANAGER:
      return OT_MANAGER_ACCESS.includes(user?.role as USER_ROLES);
    case USER_ROLE_ACCESS_KEY.NURSE:
      return NURSE_ACCESS.includes(user?.role as USER_ROLES);
    case USER_ROLE_ACCESS_KEY.CASE_SCHEDULER:
      return CASE_SCHEDULER_ACCESS.includes(user?.role as USER_ROLES);
    default:
      return false;
  }
}

export default getUserRoleAccess;
